// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-link{display:block;width:100%;text-align:left;font-family:VNPolarisWeb, Arial Narrow, sans-serif;font-size:0.875rem;font-weight:700;--tw-text-opacity:1;color:rgb(34 41 47 / var(--tw-text-opacity))}.submenu .footer-link{margin-bottom:0px;font-weight:400}a.footer-link{cursor:pointer}a.footer-link:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
